






















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ISellProduct from '@/store/models/ISellProduct';
import ISellsDetail from '@/store/models/ISellsDetail';
import ISellsDetailPallets from '@/store/models/ISellsDetailPallets';
import IRolePermission from '@/store/models/IRolePermission';
import Snackbar from '@/components/shared/Snackbar.vue';
import IStock from '@/store/models/IStock';
import SellsDetailPalletStockSelector from '@/components/selectors/Sells/SellsDetailPalletStockSelector.vue';
import { IsEqualCustomizer } from 'lodash';
import ISells from '@/store/models/ISells';
@Component({
    components: {
        Snackbar,
        SellsDetailPalletStockSelector
    }
})
export default class SellsDetailPalletSelector extends Vue {
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    SellDetailList !: ISellsDetail[];
    @Prop({ type: Array, required: true })
    SellDetailPalletsList !: ISellsDetailPallets[];
    @Prop({ type: Array, required: true })
    StockList !: IStock[];
    @Prop({ default: false })
    overlay !: boolean;
    @Prop({ type: Boolean, default: false })
    ScannerActive !: boolean;
    @Prop()
    SelectedSell !: ISells;

    headersSellDetailProducts: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        // { text: 'Total pallets', value: 'totalPallets' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'In sell detail', value: 'inSellDetailCases' }
    ];
    headersSellDetailPallet: any = [
        { text: 'Good', align: 'start', value: 'goodName' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Pallet type', value: 'listPalletName' },
        { text: 'Pallet id', value: 'idPallet' },
        { text: 'Location', value: 'location' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Actions', value: 'actions' }
    ];

    selectedSellProduct: ISellProduct[] = [];
    selectedSellDetailPallet: ISellsDetailPallets[] = [];
    searchSellDetailPallet: string = "";
    selectedStockCustomerToSell : IStock[] | null = null;
    dialog: boolean = false;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;

    get formTitle(): string {
        if (!this.selectedSellProduct || this.selectedSellProduct.length === 0) {
            return "Customer stock available";
        }

        const item = this.selectedSellProduct[0];
        const remaining = item.totalCases - item.inSellDetailCases;

        return `Select pallets for ${item.goodName} - Remaining cases: ${remaining}`;
    }

    get canEdit() {
        if (this.SelectedSell) {
            if (this.SelectedSell.statusName.toLowerCase() === 'completed') {
                return false;
            }
        }
        return true;
    }

    get SellDetailProducts(): ISellProduct[] {
        let sellDetailProducts: ISellProduct[] = [];

        if (this.SellDetailList.length > 0) {
            this.SellDetailList.forEach(p => {
                let product: ISellProduct = {} as ISellProduct;
                product.goodName = p.goodName;

                if (this.SellDetailPalletsList.length === 0) {
                    product.inSellDetailCases = 0;
                } else {
                    let pallets = this.SellDetailPalletsList.filter(s => s.idSellDetail === p.id);
                    product.inSellDetailCases = pallets.reduce((sum, pallet) => sum + Number(pallet.totalCases || 0), 0);
                }

                product.totalCases = Number(p.totalCases || p.casesAmountPallet || 0);
                product.idSellDetail = p.id;
                product.totalGoods = (p.goodsPerCase || 0) * product.totalCases;

                sellDetailProducts.push(product);
            });
        }

        return sellDetailProducts;
    }

    get SellDetailPalletListFiltered() : IStock[] {
        let stockFiltered: IStock[] = [];
        if (this.StockList.length === 0) {
            this.getCustomerStockFiltered();
        }
        if (this.selectedSellProduct.length > 0) {
            let sellDetailProductSelected = this.SellDetailPalletsList.filter(s => s.idSellDetail === this.selectedSellProduct[0].idSellDetail);
            if (this.StockList.length > 0) {
                sellDetailProductSelected.forEach(p => {
                    let product: IStock = {} as IStock;
                    product.goodName = p.goodName;
                    product.listPalletName = p.palletTypeName;
                    product.idPallet = p.idPallet;
                    product.totalCases = p.totalCases;
                    let index = this.StockList.findIndex(s => s.idPallet === p.idPallet);
                    if (index > -1) {
                        product.location = this.StockList[index].location;
                    }
                    product.warehouseName = p.warehouseName;
                    stockFiltered.push(product);
                });
            }
        }
        return stockFiltered;
    }

    get StockListFiltered() {
        let sellDetailSeletedIndex = this.SellDetailList.findIndex(s => s.id === this.selectedSellProduct[0].idSellDetail);
        let stock = this.StockList.filter(s => s.codeInbounds === this.SellDetailList[sellDetailSeletedIndex].inboundCode && s.idListPallet === this.SellDetailList[sellDetailSeletedIndex].idListPallet)
        .filter(s => s.goodName === this.SellDetailList[sellDetailSeletedIndex].goodName && s.idInboundDeliveryNoteDetail === this.SellDetailList[sellDetailSeletedIndex].idInboundDeliveryNoteDetail);
        // .filter(s => s.goodName === this.SellDetailList[sellDetailSeletedIndex].goodName && s.totalCases === this.SellDetailList[sellDetailSeletedIndex].totalCases / this.SellDetailList[sellDetailSeletedIndex].palletsAmount).filter(s => s.idInboundDeliveryNoteDetail === this.SellDetailList[sellDetailSeletedIndex].idInboundDeliveryNoteDetail);
        if (this.SellDetailPalletsList.length > 0) {
            let palletIds = this.SellDetailPalletsList.map(p => p.idPallet);
            stock = stock.filter(p => !palletIds.includes(p.idPallet));
        }
        return stock;
    }

    getColor(item: ISellProduct) {
        if (item.inSellDetailCases === null) {
            item.inSellDetailCases = 0;
            return 'white';
        } else if (item.inSellDetailCases < item.totalCases) return 'orange';
        else if (item.inSellDetailCases === item.totalCases) return 'green';
        item.inSellDetailCases = 0;
        return 'white';
    }

    deleteSellDetailPallet(item: IStock) {
        let index = this.SellDetailPalletsList.findIndex(p => p.idPallet === item.idPallet);
        if (index !== -1) {
            this.selectedSellProduct[0].inSellDetailCases = this.selectedSellProduct[0].inSellDetailCases - this.SellDetailPalletsList[index].totalCases;
            this.$emit("deleteSellDetailPallet", this.SellDetailPalletsList[index]);
        }
    }

    getCustomerStockFiltered() {
        this.selectedStockCustomerToSell = [];
        this.$emit('getCustomerStockFiltered');
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    close() : void {
        this.dialog = false;
    }

    saveSellDetailPallets() {
        if (!this.selectedStockCustomerToSell || this.selectedStockCustomerToSell.length === 0) {
            this.$emit("showMessageWarning", "Please select at least one pallet.");
            return;
        }

        const totalCasesInStock = this.selectedStockCustomerToSell.reduce((sum, item) => sum + item.totalCases, 0);
        const remainingCases = this.selectedSellProduct[0].totalCases - this.selectedSellProduct[0].inSellDetailCases;

        if (totalCasesInStock > remainingCases) {
            this.$emit("showMessageWarning", "The selected pallets contain more cases than required.");
            return;
        }

        if (totalCasesInStock < remainingCases) {
            this.$emit("showMessageWarning", "The selected pallets do not cover all required cases.");
            return;
        }

        this.selectedSellProduct[0].inSellDetailCases =
            this.selectedSellProduct[0].inSellDetailCases + totalCasesInStock;

        this.$emit("saveSellDetailPallets", this.selectedStockCustomerToSell, this.selectedSellProduct[0]);
        this.close();
    }
}

